import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2b446178")

_pushScopeId("data-v-2b446178")
const _hoisted_1 = { class: "d-f fill" }
const _hoisted_2 = { class: "flex-1 ml-32" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_FormInput = _resolveComponent("FormInput")
  const _component_ThePasswordInput = _resolveComponent("ThePasswordInput")
  const _component_Form = _resolveComponent("Form")
  const _component_Button = _resolveComponent("Button")
  const _component_GoggleLoginButton = _resolveComponent("GoggleLoginButton")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, { useFooter: "" }, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "signinemail_2" })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "primary ml-10",
          progress: _ctx.progress,
          onClick: _ctx.submit
        }, {
          default: _withId(() => [
            _createVNode(_component_t, { path: "signinemail_5" })
          ]),
          _: 1
        }, 8, ["progress", "onClick"]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_GoggleLoginButton)
        ])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_t, { custom: "" }, {
        default: _withId(({t}) => [
          _createVNode(_component_Form, {
            ref: "form",
            schema: _ctx.emailLoginSchema,
            class: "p-16",
            onSubmit: _ctx.login
          }, {
            default: _withId(() => [
              _createVNode(_component_FormInput, {
                placeholder: t('signinemail_3'),
                class: "block",
                name: "email"
              }, null, 8, ["placeholder"]),
              _createVNode(_component_ThePasswordInput, {
                placeholder: t('signinemail_4'),
                class: "block"
              }, null, 8, ["placeholder"])
            ]),
            _: 2
          }, 1032, ["schema", "onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})